import React from 'react';
import { Button } from './ui/button';
import { siteContent } from '../data/mock';

const ProductSection = ({ onCTAClick }) => {
  const { product } = siteContent;

  return (
    <section className="product-section section-padding" data-testid="product-section" data-reveal="subtle">
      <div className="container">
        <div className="product-cta-main">
          <h2 className="product-cta-title" data-testid="product-name">{product.name}</h2>
          <p className="product-cta-subtitle">{product.subtitle}</p>

          <div className="product-cta">
            <div className="price-tag" data-testid="product-price">{product.price}</div>
            <p className="investment-note">{product.investmentNote}</p>
            <Button
              className="cta-button cta-button-large"
              onClick={onCTAClick}
              size="lg"
              data-testid="product-cta-button"
            >
              {product.ctaText}
            </Button>
            <p className="payment-info">{product.paymentNote}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductSection;
